/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Menu = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Menu"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M22 7c0-.552-.373-1-.833-1H2.833C2.373 6 2 6.448 2 7s.373 1 .833 1h18.334c.46 0 .833-.448.833-1m0 10c0-.552-.373-1-.833-1H2.833c-.46 0-.833.448-.833 1s.373 1 .833 1h18.334c.46 0 .833-.448.833-1"
      className="SVG"
    />
  </svg>
);

export const MenuIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'menu-icon'}
      icon={Menu}
      {...props}
      size={size}
    />
  );
};
